import styled from "styled-components";
import { GameSearchDefaultBox } from "./game-search.default.box";

export const GameSearchMrGreenCisBox = styled(GameSearchDefaultBox)`
     height: 100%;
      background: linear-gradient(177.59deg, 
                    ${({theme}) => theme.colors.brandPrimary} 12.03%,
                    ${({theme}) => theme.colors.brandPrimaryDark} 27.06%, 
                    ${({theme}) => theme.colors.brandPrimaryDark}  37.9%);
`;